import type { Timestamp } from 'firebase/firestore'

export const INCOTERMS = ['FCA', 'CIF', 'FOB'] as const
export type Incoterms = (typeof INCOTERMS)[number]

// red = Not completed, green = Completed, na = Not applicable (excluded from
// the completion requirement).
export type StageStatus = 'red' | 'green' | 'na'
export type ProjectStatus = 'ongoing' | 'completed'

export interface Stage {
  status: StageStatus
  updatedAt: Timestamp | null
  updatedBy: string | null
}

/** Fixed map with keys "1".."10". */
export type StageMap = Record<string, Stage>

export type GeoStatus = 'pending' | 'ok' | 'not_found' | 'error'

export interface LatLng {
  lat: number
  lng: number
}

/** Route checkpoint status: pending = not started (blue), in_transit = truck en
 *  route (amber), reached = arrived (green). */
export type CheckpointStatus = 'pending' | 'in_transit' | 'reached'

/** An admin-managed intermediate route checkpoint (e.g. a border crossing). */
export interface Waypoint {
  id: string
  name: string
  /** Corridor step this checkpoint belongs to, e.g. "Exit DR Congo → Zambia". */
  label: string
  lat: number
  lng: number
  status: CheckpointStatus
}

/** Server-owned geocoding block, written only by the geocode Cloud Function (blueprint §7.4). */
export interface ProjectGeo {
  delivery: LatLng | null
  origin: LatLng | null
  status: GeoStatus
  geocodedAt: Timestamp | null
}

/** Firestore `projects/{projectId}` document (blueprint §4.1). */
export interface ProjectDoc {
  name: string
  contractNumber: string
  productName: string
  productQuantity: string
  incoterms: Incoterms
  deliveryLocation: string
  originLocation: string | null
  geo: ProjectGeo
  supplierUid: string
  supplierName: string
  clientUid: string
  clientName: string
  status: ProjectStatus
  startDate: Timestamp
  completionDate: Timestamp | null
  durationDays: number | null
  stages: StageMap
  greenCount: number
  /** Ordered intermediate route checkpoints (admin-managed). Optional. */
  waypoints?: Waypoint[]
  /** Status of the final leg / arrival at the destination (admin-managed). */
  deliveryStatus?: CheckpointStatus
  createdAt: Timestamp
  createdBy: string
}
